import {ModelTypes} from '@catcore/utils/json-schema';
import {ProjectFeaturesLandingComponent} from '@catdetails/components/landing-pages/project-features-landing/project-features-landing.component';
import {ProjectUnitLandingComponent} from '@catdetails/components/landing-pages/project-unit-landing/project-unit-landing.component';
import {GuiZoneFormComponent} from '@catmodules/models/gui-zone/components/gui-zone-form/gui-zone-form.component';
import {ProjectGgwDeviceFormComponent} from "@catmodules/models/ggw-device/components/project-ggw-device-form/project-ggw-device-form.component";
import {GgwDynamicRouteTemplateFormComponent} from "@catmodels/ggw-dynamic-routes/components/ggw-dynamic-route-template-form/ggw-dynamic-route-template-form.component";
import {ProjectEvidFunctionsLandingComponent} from "@catmodels/project-evid-functions/components/project-evid-functions-landing/project-evid-functions-landing.component";

const componentMap = new Map();
componentMap.set(ModelTypes.GuiZone, GuiZoneFormComponent);
componentMap.set(ModelTypes.ProjectFeature, ProjectFeaturesLandingComponent);
componentMap.set(ModelTypes.ProjectUnit, ProjectUnitLandingComponent);
componentMap.set(ModelTypes.ProjectGgwDevice, ProjectGgwDeviceFormComponent);
componentMap.set(ModelTypes.ProjectEvidFunctions, ProjectEvidFunctionsLandingComponent);
componentMap.set(ModelTypes.ProjectGgwDynamicRouteTemplate, GgwDynamicRouteTemplateFormComponent);

export const modelFormsForResource = componentMap;



// WEBPACK FOOTER //
// /agent/workspace/CUS-LHT_NICE_nto_nto_CAT_master@2/app/Resources/Public/src/app/modules/project-details/shared/model-forms-for-resource.map.ts